import {FormModel} from '@xh/hoist/cmp/form';
import {HoistModel, managed, SelectOption, TaskObserver, XH} from '@xh/hoist/core';
import {required} from '@xh/hoist/data';
import {
    Roles,
    Security,
    SecuritySubTypeEnum,
    SecurityTypeEnum
} from '../../../../../data/DataTypes';
import {Icon} from '@xh/hoist/icon';
import {map, sortBy} from 'lodash';

export class SecurityEditModel extends HoistModel {
    apiTask = TaskObserver.trackLast({message: 'Saving...'});
    @managed formModel = this.createFormModel();

    async load(id: number) {
        if (id) {
            const security = await XH.secMasterService.fetchSecurityByIdAsync(id);
            this.formModel.init(security);
        } else {
            this.formModel.init({});
        }
    }

    async save() {
        if (!XH.entitlementService.hasRole(Roles.SEC_MASTER_MANAGER)) {
            XH.dangerToast('You do not have permission to update.');
            return;
        }

        const security = await XH.secMasterService
            .saveSecurityAsync(this.security)
            .catchDefault({})
            .linkTo(this.apiTask);
        this.formModel.init(security);
    }

    revert() {
        XH.confirm({
            message: 'Undo all changes?',
            icon: Icon.question(),
            title: 'User confirmation required'
        }).then(result => {
            if (result) this.formModel.reset();
        });
    }

    get isVlid(): boolean {
        return this.formModel.isValid;
    }

    get hasChanges(): boolean {
        return this.formModel.isDirty;
    }

    get security(): Security {
        return this.formModel.getData() as Security;
    }

    get typeOptions(): SelectOption[] {
        const enumEntries = Object.entries(SecurityTypeEnum);
        const options = map(enumEntries, ([key, value]) => ({
            value: key,
            label: value
        }));
        return sortBy(options, 'value');
    }

    get subTypeOptions(): SelectOption[] {
        const enumEntries = Object.entries(SecuritySubTypeEnum);
        const options = map(enumEntries, ([key, value]) => ({
            value: key,
            label: value
        }));
        return sortBy(options, 'value');
    }

    private createFormModel() {
        return new FormModel({
            fields: [
                {name: 'id', initialValue: 0},
                {name: 'type', rules: [required]},
                {name: 'subType', rules: [required]},
                {name: 'name', rules: [required]},
                {name: 'ticker', rules: [required]},
                {name: 'exchange'},
                {name: 'cusip'},
                {name: 'isin'},
                {name: 'sik'},
                {name: 'country'},
                {name: 'currency'},
                {name: 'sector'},
                {name: 'industry'},
                {name: 'beta'},
                {name: 'lastDividend'},
                {name: 'dcf'},
                {name: 'pricingStrategy'},
                {name: 'updated', initialValue: new Date().toISOString()},
                {name: 'updatedBy'},
                {name: 'status', initialValue: 0},
                {name: 'timestamp'}
            ]
        });
    }
}
